
<div class="popup-container">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="heading">Store Photo Gallery</h3>
    <button class="close-btn" (click)="dialogRef.close()">×</button>
  </div>

  <div class="popup-content">
    <img [src]="data.images[currentIndex].location" class="popup-image" />
  </div>

  <div class="thumbnail-wrapper">
    <button class="prev-btn" (click)="scrollThumbnails(-1)">❮</button>
    <div class="thumbnail-container" #thumbnailScroll>
      <img *ngFor="let img of data.images; let i = index" [src]="img.location"
        [class.active]="i === currentIndex" (click)="currentIndex = i" />
    </div>
    <button class="next-btn" (click)="scrollThumbnails(1)">❯</button>
  </div>
</div>
